import { StyledTd } from "../cell/baseTd.jsx";
import { Brand, BrandChip, getBrandID } from "../../../schema/pmBrand.js";
import { Setter } from "solid-js";
import { FilterCondition } from "../../../schema/filter.js";
import { preview } from "vite";

export const BrandCell = (props: {
  brand: Brand;
  setFilterCondition: Setter<FilterCondition>;
  noFilter?: boolean;
}) => {
  const noFilter = props.noFilter ?? false;

  const applyFilter = (brand: Brand) => {
    props.setFilterCondition((prev) => ({
      ...prev,
      brand: [brand],
    }));
  };
  const cell = (
    <StyledTd>
      <BrandChip
        onClick={(e) => {
          if (!noFilter) applyFilter(e.target.innerHTML as Brand);
        }}
        macaronBrand={getBrandID(props.brand)}
        macaronNoFilter={noFilter}
      >
        {props.brand}
      </BrandChip>
    </StyledTd>
  );
  return cell;
};
